import { AuthGuard } from './guards/auth-guard.guard';
import { HomeComponent } from './pages/home/home.component';
import { IsloggedAuthGuard } from './guards/islogged-auth.guard';
import { LoginComponent } from './pages/login/login.component';
import { MyAccessionsDetailComponent } from './pages/permission-manager/my-accessions/my-accessions-detail/my-accessions-detail.component';
import { MyAccessionsListReceivedComponent } from './pages/permission-manager/my-accessions/my-accessions-list/my-accessions-list-received/my-accessions-list-received.component';
import { MyAccessionsListSentComponent } from './pages/permission-manager/my-accessions/my-accessions-list/my-accessions-list-sent/my-accessions-list-sent.component';
import { NewAccessionComponent } from './pages/permission-manager/new-accession/new-accession.component';
import { NewProjectComponent } from './pages/catalog-ia/projects/new-project/new-project.component';
import { ProjectsListComponent } from './pages/catalog-ia/projects/projects-list/projects-list.component';
import { Routes, provideRouter } from '@angular/router';
import { SystemOfIaComponent } from './pages/catalog-ia/system-of-ia/systems-of-ia-list/system-of-ia.component';
import { ProjectDetailsComponent } from './pages/catalog-ia/projects/project-details/project-details.component';
import { HistoricosComponent } from './pages/permission-manager/historical-data-use/historical-data-use.component';
import { SystemOfIaDetailsComponent } from './pages/catalog-ia/system-of-ia/system-of-ia-details/system-of-ia-details.component';
import { NewSystemOfIaComponent } from './pages/catalog-ia/system-of-ia/new-system-of-ia/new-system-of-ia.component';
import { AccessDeniedComponent } from './pages/access-denied/access-denied.component';
import { EditRptsComponent } from './pages/permission-manager/my-accessions/edit-rtps/edit-rtps.component';
import { ProjectReviewComponent } from './pages/catalog-ia/projects/project-review/project-review.component';
import { DeploySystemOfIaComponent } from './pages/catalog-ia/system-of-ia/deploy-system-of-ia/deploy-system-of-ia.component';
import { ProjectCorrectionComponent } from './pages/catalog-ia/projects/project-correction/project-correction/project-correction.component';
import { DeploySystemOfAiDetailComponent } from './pages/catalog-ia/system-of-ia/deploy-system-of-ai-detail/deploy-system-of-ai-detail.component';
import { DeploySystemReviewComponent } from './pages/catalog-ia/system-of-ia/deploy-system-review/deploy-system-review.component';
import { DeploySystemCorrectionComponent } from './pages/catalog-ia/system-of-ia/deploy-system-correction/deploy-system-correction.component';
import { SystemReviewComponent } from './pages/catalog-ia/system-of-ia/system-review/system-review.component';
import { SystemCorrectionComponent } from './pages/catalog-ia/system-of-ia/system-correction/system-correction.component';
import { AiSolutionUsageListComponent } from './pages/catalog-ia/ai-solution-usage/ai-solution-usage-list/ai-solution-usage-list.component';
import { NewAiSolutionUsageComponent } from './pages/catalog-ia/ai-solution-usage/new-ai-solution-usage/new-ai-solution-usage.component';
import { NewAiSolutionUsagePhase2Component } from './pages/catalog-ia/ai-solution-usage/new-ai-solution-usage-phase2/new-ai-solution-usage-phase2.component';
import { AiSolutionUsageDetailComponent } from './pages/catalog-ia/ai-solution-usage/ai-solution-usage-detail/ai-solution-usage-detail.component';
import { ReportViewerComponent } from './pages/catalog-ia/report-viewer/report-viewer.component';

export const routes: Routes = [
  {
    path: 'inicio',
    component: HomeComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'registro',
    component: LoginComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [IsloggedAuthGuard],
  },
  {
    path: '',
    redirectTo: 'registro',
    pathMatch: 'full',
  },
  {
    path: 'mis-adhesiones/listado/enviadas',
    component: MyAccessionsListSentComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'mis-adhesiones/listado/recibidas',
    component: MyAccessionsListReceivedComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'nueva-adhesion',
    component: NewAccessionComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'mis-adhesiones/detalles/:id',
    component: MyAccessionsDetailComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'mis-adhesiones/detalles/editar-rpts/:id',
    component: EditRptsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/proyectos/listado-proyectos',
    component: ProjectsListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/proyectos/detalles/:id',
    component: ProjectDetailsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/proyectos/nuevo-proyecto',
    component: NewProjectComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/uso-de-solucion-ia/listado-uso-de-solucion-ia',
    component: AiSolutionUsageListComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/uso-de-solucion-ia/nuevo-uso-de-solucion-ia',
    component: NewAiSolutionUsageComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/uso-de-solucion-ia/nuevo-uso-de-solucion-ia-fase2',
    component: NewAiSolutionUsagePhase2Component,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/uso-de-solucion-ia/detalles/:id',
    component: AiSolutionUsageDetailComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/visor-informe',
    component: ReportViewerComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/listado-sistemas',
    component: SystemOfIaComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/detalles/:id',
    component: SystemOfIaDetailsComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/detalles/:id/revision',
    component: SystemReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/detalles/:id/subsanar',
    component: SystemCorrectionComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/:id/desplegar-sistema',
    component: DeploySystemOfIaComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/despliegue/detalles/:id',
    component: DeploySystemOfAiDetailComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/despliegue/detalles/:id/revision',
    component: DeploySystemReviewComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/despliegue/detalles/:id/subsanar',
    component: DeploySystemCorrectionComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/nuevo-sistema/por-proyecto/:id/:name/:code/:orgcode',
    component: NewSystemOfIaComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/sistemas-de-ia/nuevo-sistema',
    component: NewSystemOfIaComponent,
    runGuardsAndResolvers: 'always',
    canActivate: [AuthGuard],
  },
  { path: 'uso-datos/cedidos', component: HistoricosComponent, canActivate: [AuthGuard] },
  { path: 'uso-datos/adheridos', component: HistoricosComponent, canActivate: [AuthGuard] },
  {
    path: 'acceso-denegado',
    component: AccessDeniedComponent,
  },
  {
    path: 'catalogo-ia/proyectos/detalles/:id/revision',
    component: ProjectReviewComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'catalogo-ia/proyectos/detalles/:id/subsanar',
    component: ProjectCorrectionComponent,
    canActivate: [AuthGuard],
  },
];

export const routeProviders = [provideRouter(routes)];
